'use strict'

export default (mockAxios) => {
  // 選択用きっかけ情報一覧
  mockAxios.onGet(`/extriggers/choices`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'name': 'サンプルきっかけ'
      }
    ]
  })

  // 一覧
  mockAxios.onGet(`/extriggers`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'name': 'サンプルきっかけ',
        'seqno': 18
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // きっかけ情報取得
  mockAxios.onGet(new RegExp(`/extriggers/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'id': 1,
      'name': 'サンプルきっかけ',
      'seqno': 18
    }
  })

  // 新規登録
  mockAxios.onPost(`/extriggers`).reply(201, {
    'success': true,
    'data': {
      'id': 1
    }
  })

  // 変更
  mockAxios.onPut(new RegExp(`/extriggers/\\d+`)).reply(201, {
    'success': true,
    'data': {
    }
  })

  // 削除
  mockAxios.onDelete(new RegExp(`/extriggers/\\d+`)).reply(200, {
    'success': true,
    'data': {
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/extriggerRepositoryMock.js